import React, { useEffect, useState } from "react";
import api from '../../services/api';
import Modal from 'react-modal';
import Flex from '@react-css/flex';
import Swal from "sweetalert2";
import DatePicker from 'react-datepicker';
import InputMask from "react-input-mask";
import { StyledForm } from "../../styled-components/StyledForm.style";
import { ToggleSwitchFilters } from "../ToggleSwitchFilters";
import { Multiselect } from 'multiselect-react-dropdown';

export const ModalCalendarioFeriadosEventosAdicionar = ({ isOpen, setIsOpen, ano, idRecessoCompetencia, onRequestClose }) => {
    const [isLoading, setisLoading] = useState(false);
    const [eventos, setEventos] = useState([]);

    const empresasList = [
        { idEmpresa: 1, nomeEmpresa: 'Critério Experts' },
        { idEmpresa: 2, nomeEmpresa: 'Adjusters' },
    ];

    const style = {
        content: {
            top: '50%', left: '50%', right: 'auto', bottom: 'auto',
            marginRight: '-50%', transform: 'translate(-50%, -50%)',
            borderRadius: "0px", minWidth: '50%', maxWidth: '60%',
            overflowY: 'auto', minHeight: '45%', maxHeight: '90%'
        },
        overlay: { zIndex: 9999 }
    };

    const closeModal = () => {
        setisLoading(false);
        setIsOpen(false);
        if (onRequestClose) onRequestClose();
        setEventos(prevEventos => 
            prevEventos.filter(e => e.isReadOnly || (e.data && e.descricao.trim() !== ''))
        );
    }

    const buscarFeriadosAPIExterna = async (anoSearch) => {
        try {
            const response = await api.get(`WipRecesso/feriados/${anoSearch}`);
            const list = response.data.data; 

            const feriadosMapeados = list.map((feriado, index) => {
                const [year, month, day] = feriado.date.split('-');
                return {
                    id: `api-externa-${index}`,
                    data: new Date(year, month - 1, day),
                    descricao: feriado.name,
                    isTodasEmpresas: true,
                    empresasSelecionadas: [],
                    isReadOnly: true 
                };
            });
            return feriadosMapeados;
        } catch (err) {
            console.error("Erro ao buscar feriados na API externa:", err);
            return [];
        }
    }

    const carregarPeriodos = async (anoSearch) => {
        setisLoading(true);
        try {
            const oficiais = await buscarFeriadosAPIExterna(anoSearch);
            const response = await api.get(`WipRecesso/periodos/${anoSearch}`);
            const periodosBanco = response.data.data;

            if (periodosBanco && periodosBanco.length > 0) {
                // REGRA APLICADA: Se tem no banco, usa APENAS o banco e ignora os dados da API Externa
                const periodosMapeados = periodosBanco.map((periodo) => {
                    const dataBanco = new Date(periodo.dataInicial);
                    
                    const isFeriadoOficial = oficiais.some(ofc => 
                        ofc.descricao === periodo.nomeRecesso && 
                        ofc.data.getDate() === dataBanco.getDate() && 
                        ofc.data.getMonth() === dataBanco.getMonth()
                    );

                    const empresasCompletas = (periodo.empresasVinculadas || []).map(empBanco => {
                        return empresasList.find(e => e.idEmpresa === empBanco.idEmpresa) || empBanco;
                    });

                    return {
                        id: periodo.idRecessoCompetenciaPeriodo,
                        data: dataBanco,
                        descricao: periodo.nomeRecesso,
                        isTodasEmpresas: periodo.isTodasEmpresas,
                        empresasSelecionadas: empresasCompletas, 
                        isReadOnly: isFeriadoOficial 
                    };
                });
                setEventos(periodosMapeados);
            } else {
                setEventos(oficiais);
            }
        } catch (err) {
            console.error("Erro ao carregar os períodos do calendário:", err);
            Swal.fire('Erro', 'Ocorreu um erro ao consultar os dados do calendário.', 'error');
        } finally {
            setisLoading(false);
        }
    }

    const adicionarEventoManual = () => {
        const novoEvento = {
            id: `manual-${Date.now()}`,
            data: null, 
            descricao: '',
            isTodasEmpresas: true, 
            empresasSelecionadas: [],
            isReadOnly: false
        };
        setEventos([...eventos, novoEvento]);
    };

    const removerEventoManual = (idParaRemover) => {
        setEventos(eventos.filter(evento => evento.id !== idParaRemover));
    };

    // ==========================================
    // BLOQUEIO DE DATA DUPLICADA NO ONCHANGE
    // ==========================================
    const handleInputChange = (id, field, value) => {
        if (field === 'data' && value) {
            // Verifica se a data escolhida já existe em OUTRA linha da lista
            const dataJaExiste = eventos.some(e => 
                e.id !== id && 
                e.data && 
                e.data.getFullYear() === value.getFullYear() &&
                e.data.getMonth() === value.getMonth() &&
                e.data.getDate() === value.getDate()
            );

            if (dataJaExiste) {
                Swal.fire('Data Indisponível', 'Já existe um feriado ou evento cadastrado para este dia. Escolha outra data.', 'warning');
                return; // Aborta a alteração para não deixar duplicar
            }
        }

        setEventos(eventos.map(evento => 
            evento.id === id ? { ...evento, [field]: value } : evento
        ));
    };

    const handleToggleTodasEmpresas = (id) => {
        setEventos(eventos.map(evento => 
            evento.id === id ? { ...evento, isTodasEmpresas: !evento.isTodasEmpresas } : evento
        ));
    };

    const handleMultiselectChange = (selectedList, idEvento) => {
        setEventos(eventos.map(evento => 
            evento.id === idEvento ? { ...evento, empresasSelecionadas: selectedList } : evento
        ));
    };

    // ==========================================
    // VALIDAÇÃO FINAL E SAVE
    // ==========================================
    const handleSalvar = async () => {
        const eventosInvalidos = eventos.filter(e => (!e.data || !e.descricao));
        
        if (eventosInvalidos.length > 0) {
            Swal.fire('Atenção', 'Preencha a data e a descrição de todos os eventos antes de salvar.', 'warning');
            return;
        }

        // Verificação final de segurança para garantir que nenhuma duplicidade passou despercebida
        const datasVistas = new Set();
        for (const e of eventos) {
            if (!e.data) continue;
            const dataStr = `${e.data.getFullYear()}-${e.data.getMonth()}-${e.data.getDate()}`;
            if (datasVistas.has(dataStr)) {
                Swal.fire('Data Duplicada', `A data ${e.data.toLocaleDateString('pt-BR')} está duplicada. Remova a linha repetida antes de salvar.`, 'error');
                return;
            }
            datasVistas.add(dataStr);
        }

        if (!idRecessoCompetencia) {
            Swal.fire('Erro Estrutural', 'O ID da Competência não foi recebido pelo modal. Verifique a tela pai.', 'error');
            return;
        }

        const payloadEventos = eventos.map(e => ({
            data: e.data.toISOString(), 
            descricao: e.descricao,
            isTodasEmpresas: e.isTodasEmpresas,
            empresasSelecionadas: e.isTodasEmpresas ? [] : e.empresasSelecionadas.map(emp => emp.idEmpresa)
        }));

        const payloadFinal = {
            idRecessoCompetencia: idRecessoCompetencia,
            eventos: payloadEventos
        };

        setisLoading(true);
        try {
            await api.post('WipRecesso/periodos', payloadFinal);
            Swal.fire('Sucesso', 'Configurações do calendário salvas com sucesso!', 'success').then(() => {
                closeModal();
            });
        } catch (error) {
            console.error("Erro ao salvar períodos:", error);
            const msgErro = error.response?.data?.notification?.messageReturn || 'Não foi possível salvar as configurações do calendário.';
            Swal.fire('Erro no Banco', msgErro, 'error');
        } finally {
            setisLoading(false);
        }
    };

    useEffect(() => {
        if(isOpen && ano) {
            carregarPeriodos(ano);
        }
    }, [isOpen, ano])

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={closeModal}
            contentLabel="Modal Adicionar Feriados e Eventos"
            style={style}
            ariaHideApp={false}
            shouldCloseOnOverlayClick={false}
        >
            <StyledForm>
                <Flex>
                    <Flex.Item className="modal-width">
                        <div className="d-flex justify-content-between align-items-center">
                            <div className="pull-left">
                                <p className="modal-title">
                                    <i className="fa fa-calendar pe-2" style={{ fontSize: '24px', color: '#EE4B21' }}></i>
                                    Configurar Feriados / Eventos ({ano})
                                </p>
                            </div>
                            <div className="pull-right">
                                <p className="modal-close" onClick={closeModal}><button type="button" className="default-button-red-small px-2">X</button></p>
                            </div>
                        </div>
                    </Flex.Item>
                </Flex>
                { isLoading ? 
                (
                    <div className="text-center">
                        <div className="text-items-center">
                            <div className="spinner-border ms-auto mt-2" style={{ color: "#EE4B21" }} role="status" aria-hidden="true"></div>
                            <div className="mt-2">
                                <strong style={{ color: "#EE4B21" }}>Processando dados do calendário...</strong>
                            </div>
                        </div>
                </div>
                ) : (
                    <div style={{ padding: '0 10px 20px 10px' }}>
                        <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '20px' }}>
                            <thead>
                            <tr style={{ borderBottom: '2px solid #ccc', textAlign: 'left' }}>
                                <th style={{ padding: '10px', width: '20%' }}>Data</th>
                                <th style={{ padding: '10px', width: '45%' }}>Descrição</th>
                                <th style={{ padding: '10px', width: '25%' }}>Todas as Empresas?</th>
                                <th style={{ padding: '10px', width: '10%', textAlign: 'center' }}>Ações</th>
                            </tr>
                            </thead>
                            <tbody>
                            {eventos.map((evento) => {
                                const toggleLinhaConfig = { 
                                    name: `toggle-${evento.id}`, 
                                    id: `toggle-${evento.id}`, 
                                    label: evento.isTodasEmpresas ? 'Sim' : 'Não', 
                                    status: evento.isTodasEmpresas, 
                                    checked: evento.isTodasEmpresas 
                                };

                                return (
                                <tr key={evento.id} style={{ borderBottom: '1px solid #eee' }}>
                                
                                <td style={{ padding: '10px' }}>
                                    <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                                        <DatePicker 
                                            key={`date-${evento.id}`} 
                                            dateFormat="dd/MM/yyyy" 
                                            locale="pt-BR" 
                                            selected={evento.data} 
                                            onChange={(date) => handleInputChange(evento.id, 'data', date)} 
                                            disabled={evento.isReadOnly}
                                            minDate={new Date(ano, 0, 1)} 
                                            maxDate={new Date(ano, 11, 31)}
                                            customInput={
                                                <InputMask 
                                                    mask="99/99/9999" 
                                                    className="input-form py-2 pe-4"
                                                    style={{ width: '100%', paddingRight: '30px' }} 
                                                />
                                            }
                                        />
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#999" viewBox="0 0 16 16" style={{ position: 'absolute', right: '10px', pointerEvents: 'none' }}>
                                            <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/>
                                        </svg>
                                    </div>
                                </td>

                                <td style={{ padding: '10px' }}>
                                    <input 
                                    type="text" 
                                    value={evento.descricao} 
                                    placeholder="Ex: Festa de Fim de Ano"
                                    onChange={(e) => handleInputChange(evento.id, 'descricao', e.target.value)}
                                    disabled={evento.isReadOnly}
                                    style={{ padding: '5px', width: '100%' }}
                                    className="input-form py-2 pe-4"
                                    />
                                </td>

                                <td style={{ padding: '10px', verticalAlign: 'middle' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                                        <ToggleSwitchFilters 
                                            key={`toggle-key-${evento.id}`}
                                            config={toggleLinhaConfig} 
                                            setStatus={() => handleToggleTodasEmpresas(evento.id)} 
                                        />

                                        {!evento.isTodasEmpresas && (
                                            <div style={{ minWidth: '220px' }}>
                                                <Multiselect
                                                    className="searchWrapperCustom"
                                                    placeholder={'Selecione as Empresas'}
                                                    showCheckbox="true"
                                                    options={empresasList}
                                                    onSelect={(list) => handleMultiselectChange(list, evento.id)}
                                                    onRemove={(list) => handleMultiselectChange(list, evento.id)}
                                                    displayValue="nomeEmpresa"
                                                    selectedValues={evento.empresasSelecionadas}
                                                    showArrow={true}
                                                />
                                            </div>
                                        )}
                                    </div>
                                </td>

                                <td style={{ padding: '10px', textAlign: 'center' }}>
                                    {!evento.isReadOnly && (
                                        <button
                                            type="button"
                                            onClick={() => removerEventoManual(evento.id)}
                                            style={{ backgroundColor: '#dc3545', color: '#fff', border: 'none', borderRadius: '4px', padding: '6px 12px', cursor: 'pointer', fontWeight: 'bold', fontSize: '14px' }}
                                            title="Excluir linha"
                                        >
                                            <i className="fa fa-trash" style={{ fontSize: '16px' }}></i>
                                        </button>
                                    )}
                                </td>
                                </tr>
                                );
                            })}
                            </tbody>
                        </table>

                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <button 
                                type="button" 
                                onClick={adicionarEventoManual}
                                style={{ padding: '10px 15px', fontSize: '14px', cursor: 'pointer', backgroundColor: '#6c757d', color: '#fff', border: 'none', borderRadius: '4px', fontWeight: 'bold' }}
                            >
                                + Adicionar Evento 
                            </button>

                            <button 
                                type="button" 
                                onClick={handleSalvar}
                                style={{ padding: '10px 15px', fontSize: '14px', cursor: 'pointer', backgroundColor: '#EE4B21', color: '#fff', border: 'none', borderRadius: '4px', fontWeight: 'bold' }}
                            >
                                Salvar Configurações
                            </button>
                        </div>
                    </div>
                )}
            </StyledForm>
        </Modal>
    );
}